import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Box, CircularProgress } from '@mui/material';

const PremiumRedirect = () => {
  const { isPremiumUser, loading } = useAuth();

  if (loading) {
    // Show loading indicator while auth status is being determined
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  // Once loading is false, check premium status and redirect
  if (isPremiumUser()) {
    return <Navigate to="/mijn-content" replace />;
  } else {
    return <Navigate to="/diensten/zelfcoaching?scrollTo=pakketten" replace />;
  }
};

export default PremiumRedirect; 